import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/dist/client/link.js")